"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateString = exports.sanitizeString = exports.sortByFirstNumberInStringsComparator = exports.replaceAt = exports.getFirstNumberInString = exports.getEmailParts = void 0;
const getEmailParts = (email) => email.split("@");
exports.getEmailParts = getEmailParts;
const getFirstNumberInString = (value) => {
    const matches = value.match(/\d+/);
    if (matches)
        return parseInt(matches[0], 10);
    return null;
};
exports.getFirstNumberInString = getFirstNumberInString;
const replaceAt = (str, index, replacement) => {
    if (index < 0)
        throw new Error("Index must be non-negative");
    return str.slice(0, index) + replacement + str.slice(index + replacement.length);
};
exports.replaceAt = replaceAt;
const sortByFirstNumberInStringsComparator = (a, b) => {
    const valueA = (0, exports.getFirstNumberInString)(a);
    const valueB = (0, exports.getFirstNumberInString)(b);
    if (valueA === null && valueB === null)
        return a.localeCompare(b);
    if (valueA === null)
        return 1;
    if (valueB === null)
        return -1;
    return valueA - valueB;
};
exports.sortByFirstNumberInStringsComparator = sortByFirstNumberInStringsComparator;
function sanitizeString(inputString) {
    return inputString.replace(/[^A-Za-z0-9_-]+/g, "-");
}
exports.sanitizeString = sanitizeString;
function truncateString(inputString, maxLength) {
    if (inputString.length <= maxLength)
        return inputString;
    return `${inputString.substring(0, maxLength - 3)}...`;
}
exports.truncateString = truncateString;
//# sourceMappingURL=stringHelpers.js.map